import { render, staticRenderFns } from "./Func55Detalhe.vue?vue&type=template&id=5cd31a7a"
import script from "./Func55Detalhe.vue?vue&type=script&lang=js"
export * from "./Func55Detalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports